<template>
  <v-dialog v-model="modal" scrollable>
    <v-card>
      <v-card-title>
        Sélection d'instance
      </v-card-title>
      <v-card-subtitle>{{ subtitle }}</v-card-subtitle>
      <v-card-text>
        <v-row>
          <v-col cols="12" sm="6">
            <search-by
              :datasource="datasource"
              attr="nom"
              i18n="recherche.rechercheSimple.instance.search.nom"
            />
          </v-col>
        </v-row>
        <datasource-table style="height:480px;" :datasource="datasource">
          <template #item.id="{item}">
            <a @click="select(item)">
              {{ item.id }}
            </a>
          </template>
          <template #item.nom="{item}">
            <a @click="select(item)">
              {{ item.nom }}
            </a>
          </template>
          <template #item.typeParticipant="{item}">
            <a @select="select(item)"> </a>
          </template>
        </datasource-table>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn @click="closeModal" text>
          {{ $t('button.cancel') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import Datasource from '@/utils/datasource';

export default {
  props: {
    subtitle: {
      type: String,
    },
  },
  data() {
    var datasource = new Datasource(
      'recherche/simple/listInstanceNonAssociee',
      {
        page: 1,
        rowsPerPage: 20,
        sortBy: ['nom'],
        descending: [false],
        selectAll: this.selectAll,
        labelNamespace: 'recherche.rechercheSimple.instance.list',
        args: {
          actif: true,
        },
        fields: [
          {
            value: 'nom',
            sortable: true,
            text: this.$t(
              'recherche.rechercheSimple.instance.list.headers.nom',
            ),
          },
          {
            value: 'referent',
            sortable: true,
            text: this.$t(
              'recherche.rechercheSimple.instance.list.headers.referent',
            ),
          },
          {
            value: 'nomsGestionnaires',
            sortable: false,
            text: this.$t(
              'recherche.rechercheSimple.instance.list.headers.personnePhysique',
            ),
          },
          {
            value: 'size',
            sortable: false,
            text: this.$t(
              'recherche.rechercheSimple.instance.list.headers.numberOfUser',
            ),
          },
        ],
      },
    );
    return {
      datasource,
      modal: false,
    };
  },
  methods: {
    show(ids) {
      this.modal = true;
      this.datasource.args = {
        nom: '',
        ids: ids,
      };
      this.datasource.refresh();
    },
    select(item) {
      this.modal = false;
      this.$emit('input', { ...item });
    },
    closeModal() {
      this.modal = false;
    },
  },
};
</script>
